import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import {
  TitleCanvasElement,
  BackgroundImageCanvasElement,
  TextCanvasElement,
  VerticalTextWrapper,
  BrandCanvasElement,
  FooterCanvasElement,
  NotificationCanvasElement
} from '@/models/marketingCenter/elements';
import {
  InstagramPostFormat,
  InstagramStoryFormat,
  FacebookPostFormat
} from '@/models/marketingCenter/formats';
import { EMarketingCenterColorSchemes } from '../colorScheme';

const HelloTemplate: IMarketingCenterTemplate = {
  tag: 'Customer loyalty intro',
  title: "Hello We're on Twism",
  description:
    'Introduce your reward program to existing members and followers on your social media channels.',
  placeholders: {
    title: 'Join us on Twism',
    text: 'Earn your first Coins',
    colorScheme: EMarketingCenterColorSchemes.ORANGE
  },
  formats: [
    new InstagramStoryFormat([
      new BackgroundImageCanvasElement({}),
      new BrandCanvasElement({
        width: 80,
        height: 80,
        x: -18,
        y: 16,
        radius: 40
      }),
      new VerticalTextWrapper({
        elements: [TitleCanvasElement, TextCanvasElement],
        gapsBetween: [6],
        positions: [
          {
            x: 18,
            y: 22
          }
        ]
      }),
      new NotificationCanvasElement({
        position: {
          y: 240,
          x: 18
        }
      }),
      new FooterCanvasElement({})
    ]),
    new InstagramPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/hello/orange.svg'
      }),
      new BrandCanvasElement({
        width: 80,
        height: 80,
        x: -2,
        y: 6,
        radius: 40
      }),
      new VerticalTextWrapper({
        elements: [TitleCanvasElement, TextCanvasElement],
        gapsBetween: [6],
        positions: [
          {
            x: 18,
            y: 22
          }
        ]
      }),
      new NotificationCanvasElement({
        position: {
          y: 119,
          x: 18
        }
      }),
      new FooterCanvasElement({})
    ]),
    new FacebookPostFormat([
      new BackgroundImageCanvasElement({}),
      new BrandCanvasElement({
        width: 56,
        height: 56,
        x: -8,
        y: 6,
        radius: 28,
        borderWidth: 6
      }),
      new VerticalTextWrapper({
        elements: [TitleCanvasElement, TextCanvasElement],
        gapsBetween: [6],
        fonts: [
          {
            size: 16,
            lineHeight: 18,
            maxWidth: 170
          },
          {
            size: 8
          }
        ],
        positions: [
          {
            x: 18,
            y: 22
          }
        ]
      }),
      new NotificationCanvasElement({
        position: {
          y: 70,
          x: 14
        },
        dimensions: {
          width: 200,
          height: 60
        }
      })
    ])
  ]
};

export default HelloTemplate;
